import { render, staticRenderFns } from "./goodsListDailog.vue?vue&type=template&id=3f444ed1&scoped=true"
import script from "./goodsListDailog.vue?vue&type=script&lang=js"
export * from "./goodsListDailog.vue?vue&type=script&lang=js"
import style0 from "./goodsListDailog.vue?vue&type=style&index=0&id=3f444ed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f444ed1",
  null
  
)

export default component.exports